import React, { useState } from 'react';
import TabelaFreteService from '../../services/service.tabelafrete';
import NewSearchBarControlFormik from './search-Bar.Control.Formik';

const SearchListTabelaFretes = (props) => {
  const [tabelafrete, setTabelaFrete] = useState(null);
  const [pages, setPages] = useState(null);

  const columns = [
    {
      field: 'Id',
      headerName: 'Codigo',
      width: 90,
      key: true
    },
    {
      field: 'Nome',
      headerName: 'Nome',
      width: 150,
    }
  ];

  const columnsFilter = [
    {
      field: 'Id',
      headerName: 'Codigo',
      tipo: 'number'
    },
    {
      field: 'Nome',
      headerName: 'Nome',
      tipo: 'text'
    }
  ];

  const onSearchTitle = (filter) => {
    TabelaFreteService.getAll(filter)
      .then(response => {
        setTabelaFrete(response.data.value);
        setPages(response.data.pages);
      })
      .catch(e => {
        console.error(e);
      });
  };

  const onGetItem = (id) => {
    id && props.onLoad && props.onLoad(true);
    id && TabelaFreteService.get(id)
      .then(response => {
        if (response.response?.data.error) {
          props.onError && props.onError(response.response?.data.error);
        } else {
          response.data && onItemSelected(response.data);
        }
      })
      .catch(e => {
        props.onError && props.onError(e);
      })
      .finally(() => {
        props.onLoad && props.onLoad(false);
      });
    !id && onItemSelected(null);
  };

  const onItemSelected = (item) => {
    props.onItemSelected(item);
  };

  return (
    <>
      <NewSearchBarControlFormik
        {...props}
        pages={pages}
        onSearchTitle={onSearchTitle}
        onGetItem={onGetItem}
        onItemSelected={onItemSelected}
        data={tabelafrete}
        columns={columns}
        columnsFilter={columnsFilter}
        storagename={"TabelaFretes"}
      />
    </>
  );
}

export default SearchListTabelaFretes;
